<template>
  <div class="fixed left-0 right-0 top-0 bg-black w-full h-full bg-opacity-40 z-[99999999]">
    <div class="flex absolute bg-white w-[600px] rounded-md shadow-softxl space-y-6 flex-col items-center justify-start left-1/2 -translate-x-1/2 top-[64px] z-[9999] pb-4">
      <div class="w-full bg-primary flex items-center space-x-3 rounded-t-md shadow-sm px-4 py-3">
        <IconBell class="w-8 h-8 fill-white flex-shrink-0"/>
        <span class="text-white text-lg md:text-xl font-medium tracking-wide leading-snug">
          {{ navbarStore.notificationPopupTitle }}
        </span>
      </div>
      <div class="max-h-[75vh] overflow-y-auto rounded-lg mb-3 w-full flex flex-col space-y-4 p-4">
        <div v-html="navbarStore.notificationPopupMessage" class="pb-10"></div>
      </div>
      <div class="flex justify-center space-x-2 w-full bg-white fixed bottom-0 left-0 py-2 right-0 z-[999]">
        <MainButton @click="gotToNotifications()" type="primary">Go to notifications</MainButton>
        <MainButton @click="closePopup()" type="primary-outline">Close</MainButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import IconBell from "@/components/svg_icons/IconBell.vue";
import MainButton from "@/components/buttons/MainButton.vue";
import {useNavbarStore} from "@/stores/navbar";
import {useAuthStore} from "@/stores/auth";

const navbarStore = useNavbarStore();
const auth = useAuthStore();

const gotToNotifications = () => {
  navbarStore.closeNotificationPopup();
  navbarStore.openNotificationsList();
  closePopup();
}

const closePopup = () => {
  if (navbarStore.isTestPopupNotification === false) {
    auth.closeSiteNotificationId(navbarStore.popupNotificationId);
  }
  navbarStore.closeNotificationPopup()
}

</script>

<style scoped>

</style>